import { SVGAttributes } from 'react';

const remToPx = 10;

export type SvgProps = SVGAttributes<any>;

export const propsHelperRem = (
    width: number,
    height: number,
    props: SvgProps,
    viewBox?: string
): SvgProps => ({
    width: `${width}rem`,
    height: `${height}rem`,
    viewBox: viewBox || `0 0 ${width * remToPx} ${height * remToPx}`,
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    ...props,
});
